import type { RouteObject } from 'react-router';

import { ContentNewPage } from './ContentNew';

/**
 * `/content/new`. One `RouteObject`, so the file is `.route.tsx` singular.
 *
 * It is declared **before** `/content/:contentItemId/edit` is reached, and the
 * literal segment is what keeps `new` from being read as an identifier.
 */
export const contentNewRoute: RouteObject = {
  path: 'content/new',
  element: <ContentNewPage />,
};
